module.exports = __webpack_public_path__ + "static/banner-bg-2-f1ff5a41b132463100d98bdf764bc9a8.png";